import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import 'typeface-roboto';
import App from './app';
import './index.scss';
import {store} from './state/store';
import {Auth0Provider} from './auth/react-auth0-spa';
import config from './auth/auth_config.json';
import {Switch, Route, BrowserRouter} from 'react-router-dom';
import PrivateRoute from './auth/private-route';
import Callback from './auth/callback';
import {ThemeProvider} from '@material-ui/core/styles';
import {colorTheme} from './styles/color-theme';
import {InsightsKey} from './utilities/constants';
import {reactAI} from './services/telemetry-service';
import history from './state/history';

InsightsKey && reactAI.initialize(InsightsKey, history);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={colorTheme()}>
      <link rel="stylesheet" href="../node_modules/lato-font/css/lato-font.css" />
      <Auth0Provider
        domain={config.domain}
        client_id={config.clientId}
        redirect_uri={window.location.origin + '/callback'}
        audience={config.audience}>
        <BrowserRouter>
          <Switch>
            <PrivateRoute path="/" component={App} />
            <Route path="/callback" component={Callback} />
          </Switch>
        </BrowserRouter>
      </Auth0Provider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
);
